import { NgModule } from '@angular/core';

import { provideFormlyConfig } from '@ngx-formly/core';
import { SharedFormWrapperUiButtonModule } from '@ts/shared/form/wrapper/ui-button';

import { MoneyFieldUiComponent } from './money-field-ui/money-field-ui.component';

@NgModule({
  imports: [SharedFormWrapperUiButtonModule],
  providers: [
    provideFormlyConfig({
      types: [
        {
          name: 'money',
          component: MoneyFieldUiComponent,
          wrappers: ['form-field-labeled', 'button'],
        },
      ],
    }),
  ],
})
export class SharedMoneyFormUiFieldModule {}
